var _mask, _g, _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPersonalLoan = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "pl_cut",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 8.4,
  fill: "#000"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#3F68B5",
  mask: "url(#pl_cut)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 9.5,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 28a10 9 0 0 1 20 0Z"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 6.2,
  fill: "none",
  stroke: "#3F68B5",
  strokeWidth: 1.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.4 20.9C25.4 19.7 23.8 19.4 22.7 20.1C21.6 20.8 21.7 22 23.1 22.6C24.6 23.2 25.5 23.8 25.2 25C24.9 26.2 23.2 26.5 21.7 25.5",
  fill: "none",
  stroke: "#3F68B5",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 22.9,
  y: 19.2,
  width: 1.2,
  height: 8.6,
  rx: 0.6,
  fill: "#3F68B5"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPersonalLoan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_personal_loan.80705b563ec9c36c5aafc8b859af4310.svg";